package top.wcpe.allincore.ui.runtime.theme

/**
 * Button 控件主题令牌（ADR-0048 内部分组）。
 *
 * 由 [ControlTheme] 内部持有，`ControlTheme` 的按钮相关 accessor 委托至此——签名不变、消费者零改动。
 * 注意 `textPaddingX` 为**跨控件共享**（留 ControlTheme 核心），仅 `textPaddingY` / `textBaselineY` 为按钮专属。
 * 默认值与原 `ControlTheme.Builder` 一致（零回归）。
 */
data class ButtonTokens(
    val textPaddingY: Float = 0f,
    val textBaselineY: Float = 0f,
    val cornerRadius: Float = 0f,
    val iconSpacing: Float = DEFAULT_ICON_SPACING,
    val elevationDefault: Float = 0f,
    val elevationHover: Float = 0f,
    val elevationPressed: Float = 0f,
    val textTransform: String = DEFAULT_TEXT_TRANSFORM,
) {
    private companion object {
        private const val DEFAULT_ICON_SPACING = 2f
        private const val DEFAULT_TEXT_TRANSFORM = "none"
    }
}
